'use client';

import { useTranslations } from 'next-intl';

const GOLD = '#F5A623';
const NAVY = '#1B2D4F';

interface ShareButtonProps {
  playerId?: string;
  onShareCards: () => void;
  variant?: 'block' | 'inline';
  className?: string;
}

export function ShareButton({
  playerId,
  onShareCards,
  variant = 'block',
  className = '',
}: ShareButtonProps) {
  const t = useTranslations('Celebration');

  if (variant === 'inline') {
    return (
      <div className={className}>
        <button
          onClick={onShareCards}
          className="cursor-pointer rounded-lg border-none px-7 py-3 text-[14px] font-extrabold transition-transform duration-200 hover:scale-105 active:scale-95"
          style={{
            background: GOLD,
            color: NAVY,
          }}
        >
          {playerId ? t('shareResults') : t('shareEvent')}
        </button>
      </div>
    );
  }

  return (
    <div className={`fixed inset-x-0 bottom-0 z-40 ${className}`}>
      <button
        onClick={onShareCards}
        className="w-full cursor-pointer border-none py-4 text-[15px] font-extrabold"
        style={{
          background: GOLD,
          color: NAVY,
        }}
      >
        {playerId ? t('shareResults') : t('shareEvent')}
      </button>
    </div>
  );
}
